import { AuthService } from '@framework/services';

/**
 * Authorization header for APIs that authenticate the request themselves
 * (the HTTP interceptor does not add one for most company-admin routes).
 */
export function getAuthorizationHeader(authService: AuthService): Promise<string> {
  const gsToken = authService.getGsToken();
  if (gsToken) {
    return Promise.resolve(`GSeeker ${gsToken}`);
  }
  return authService.cognito.getIdToken().then((token) => `Bearer ${token}`);
}
